import React from "react";
import { Form } from "react-bootstrap";

import { FormControl } from "../../";

const FieldTextarea = ({ field, rows = 3, onChange, form, ...rest }) => {
  const { max } = rest;
  const { min = 0 } = rest;
  return (
    <FormControl {...field} {...form} {...rest}>
      <Form.Control
        as="textarea"
        rows={rows}
        {...field}
        {...rest}
        autoComplete="off"
        onKeyDown={(evt) => {
          if (max && evt.target.value.length >= max) {
            if (evt.keyCode != 8) {
              evt.preventDefault();
            }
          }
        }}
        onChange={(evt) => {
          if (evt.target.value == "") {
            evt.target.value = null;
          }
          onChange(evt);
        }}
      />
    </FormControl>
  );
};

export default FieldTextarea;
